import api from './api';
import {Device} from '../interfaces';

export function getDevices(params: {profileId?: number}) {
  const {profileId} = params;

  return new Promise<Device[]>((resolve, reject) => {
    try {
      api
        .get(`/devices${profileId ? `?profileId=${profileId}` : ''}`)
        .then(response => {
          resolve(response.data.devices);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function removeDevice({
  deviceId,
  profileId,
}: {
  deviceId: number;
  profileId?: number;
}) {
  return new Promise<Device[]>((resolve, reject) => {
    try {
      api
        .delete(`/devices/${deviceId}`, {
          params: {
            profileId,
          },
        })
        .then(response => {
          resolve(response.data.devices);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
